import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule} from "@angular/router";
import {Http, HttpModule, RequestOptions, XHRBackend} from "@angular/http";

import {throwIfAlreadyLoaded} from './module-import-guard';
import {SharedModule} from "../shared/shared.module";
import {HttpService} from "./services/http.service";
import {CoreRequestOptions} from "./core.request.options";
import {routes} from "./routes";
import {AuthGuard} from "./auth.guard";
import {BackendService} from "./services/backend.service";

export function initHttp(backend: XHRBackend, options: RequestOptions) {
    return new HttpService(backend, options);
}

export const requestOptionsProvider = { provide: RequestOptions, useClass: CoreRequestOptions };

@NgModule({
    imports: [
        HttpModule,
        CommonModule,
        SharedModule,
        RouterModule.forRoot(routes),
    ],
    exports: [
        HttpModule,
        CommonModule,
        SharedModule,
        RouterModule
    ],
    declarations: [
    ],
    providers: [
        {
            provide: Http,
            useFactory: initHttp,
            deps: [XHRBackend, RequestOptions]
        },
        requestOptionsProvider,
        AuthGuard,
        HttpService,
        BackendService,
    ]
})
export class CoreModule {
    constructor( @Optional() @SkipSelf() parentModule: CoreModule) {
        throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }
}


// WEBPACK FOOTER //
// /code/frontend/src/app/core/core.module.ts